<div #host role="tablist" class="eui-tabs {{ styleClass }}" [class.eui-tabs--main-navigation]="isMainNavigation" [class.eui-tabs--vertical]="isVerticalTabs" attr.data-e2e="{{ e2eAttr }}">
    <div #euiTabsItems class="eui-tabs__items" [class.eui-tabs__items--scrolling]="scrolling" (cdkObserveContent)="onContentChanges()">
        <div #euiTabsItemsWrapper class="eui-tabs__items-wrapper" [attr.data-offset]="currentOffset" role="tablist">
            <ng-container *ngFor="let tab of tabs; let i = index">
                <ng-template [ngIf]="tab.templateLabel && tab.isVisible">
                    <div tabindex="0"
                        role="tab"
                        class="eui-tab-item"
                        [class.eui-tab-item--closable]="tab.isClosable"
                        [class.eui-tab-item--active]="activeTabIndex === i"
                        [class.eui-tab-item--disabled]="tab.isDisabled"
                        [class.eui-tab-item--secondary]="tab.euiSecondary"
                        [class.eui-tab-item--primary]="tab.euiPrimary"
                        [class.eui-tab-item--info]="tab.euiInfo"
                        [class.eui-tab-item--success]="tab.euiSuccess"
                        [class.eui-tab-item--warning]="tab.euiWarning"
                        [class.eui-tab-item--danger]="tab.euiDanger"
                        [class.eui-tab-item--accent]="tab.euiAccent"
                        [class.eui-tab-item--background-filled]="tab.hasBackgroundFilled"
                        [attr.aria-disabled]="tab.isDisabled"
                        (click)="changeTab(i)"
                        [euiTooltip]="tab.tooltip"
                        (keyup)="onKeyUp($event, i)">
                        <div class="eui-tab-item__label">
                            <ng-template [cdkPortalOutlet]="tab.templateLabel.templatePortal"></ng-template>
                        </div>
                        <span euiIcon *ngIf="tab.isClosable" class="eui-icon eui-icon-close-m eui-tab__close-icon" (click)="closeTab(i, $event)" euiSizeS aria-label="With close icon"></span>
                    </div>
                </ng-template>
            </ng-container>
        </div>

        <div class="eui-tabs__right-content">
            <ng-content select="euiTabsRightContent"></ng-content>
        </div>

        <div class="eui-tabs__navigation">
            <div class="eui-tabs__navigation__left-item">
                <button (click)="goToLeft()" euiButton euiIconButton euiBasicButton [euiDisabled]="navigationLeftButtonDisabled" aria-label="Scroll left">
                    <span euiIcon iconClass="eui-icon eui-icon-angle-left"></span>
                </button>
            </div>
            <div class="eui-tabs__navigation__right-item">
                <button (click)="goToRight()" euiButton euiIconButton euiBasicButton [euiDisabled]="navigationRightButtonDisabled" aria-label="Scroll right">
                    <span euiIcon iconClass="eui-icon eui-icon-angle-right"></span>
                </button>
            </div>
        </div>
    </div>

    <ng-container *ngFor="let tab of tabs; let i = index">
        <div class="eui-tab-content" tabindex="0" *ngIf="i === activeTabIndex && tab.isVisible && tab.templateContent">
            <ng-template [cdkPortalOutlet]="tab.templateContent.templatePortal"></ng-template>
        </div>
    </ng-container>
</div>
